import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';
import { ContributorShortType } from '@pages/types';
import { colors, Text } from 'common-components';

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 0;
`;

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;

export const DataLabel = ({ children }: PropsWithChildren) => (
  <Text color={colors.gray600} style={{ flex: 1, fontWeight: 500 }}>
    {children}
  </Text>
);

export const DataValue = ({ children }: PropsWithChildren) => (
  <Text color={colors.gray400}>{children}</Text>
);

type HistoryRowPropsType = {
  date: string
  event: string
  user?: ContributorShortType
};

export const HistoryRow = ({ date, event, user }: HistoryRowPropsType) => (
  <DataRow style={{ alignItems: 'center', padding: '4px 0' }}>
    <div style={{ display: 'flex', gap: 8 }}>
      <Text color={colors.gray500}>{date}</Text>
      <Text color={colors.gray700} style={{ fontWeight: 500 }}>
        {event}
      </Text>
    </div>
    {!!user && <DataValue>{`${user.firstName} ${user.lastName}`}</DataValue>}
  </DataRow>
);
